export const RATE_LIMIT_MAX_REQUESTS = 6;
export const RATE_LIMIT_WINDOW_MS = 60 * 60 * 1000; // 1 hour
